export default __webpack_public_path__ + "static/media/hhvm.a0321a34.svg";